import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.75} y={0.75} width={34.5} height={22.5} fill="white" />
      <path
        d="M35.9987 16C35.9987 16 27.9928 21.5233 13.332 24H35.9987V16Z"
        fill="#F48120"
      />
      <path
        d="M4.07248 9.26758H2.66797V14.1879H4.07248C4.815 14.1879 5.35176 14.0089 5.82589 13.6243C6.38949 13.1591 6.72049 12.4613 6.72049 11.7367C6.71154 10.2785 5.62908 9.26758 4.07248 9.26758ZM5.19967 12.9712C4.89551 13.2396 4.51084 13.3648 3.88462 13.3648H3.62519V10.1085H3.88462C4.50189 10.1085 4.87762 10.2158 5.19967 10.5021C5.53068 10.7973 5.72749 11.2536 5.72749 11.7277C5.72749 12.2019 5.53068 12.676 5.19967 12.9712Z"
        fill="#231F20"
      />
      <path
        d="M8.11737 9.26758H7.16016V14.1879H8.11737V9.26758Z"
        fill="#231F20"
      />
      <path
        d="M10.4598 11.1564C9.88725 10.9417 9.71728 10.7986 9.71728 10.5392C9.71728 10.2261 10.0214 9.99346 10.433 9.99346C10.7192 9.99346 10.9608 10.1098 11.2023 10.396L11.7033 9.74297C11.2918 9.38513 10.7997 9.19727 10.254 9.19727C9.38628 9.19727 8.71533 9.80559 8.71533 10.6107C8.71533 11.2906 9.02844 11.6395 9.92303 11.9616C10.2988 12.0958 10.4866 12.1852 10.585 12.2389C10.7729 12.3641 10.8713 12.5431 10.8713 12.7488C10.8713 13.1514 10.5582 13.4466 10.1288 13.4466C9.67255 13.4466 9.30576 13.214 9.08211 12.7935L8.46484 13.3929C8.9032 14.046 9.43995 14.3322 10.1646 14.3322C11.1576 14.3322 11.8643 13.6702 11.8643 12.713C11.8822 11.9168 11.5512 11.559 10.4598 11.1564Z"
        fill="#231F20"
      />
      <path
        d="M12.1777 11.7366C12.1777 13.1858 13.3139 14.3041 14.7721 14.3041C15.1836 14.3041 15.5414 14.2236 15.9708 14.0178V12.8906C15.5861 13.2753 15.2462 13.4274 14.8168 13.4274C13.8506 13.4274 13.1618 12.7296 13.1618 11.7276C13.1618 10.7794 13.8685 10.0369 14.7721 10.0369C15.2283 10.0369 15.5772 10.1979 15.9708 10.5915V9.46432C15.5504 9.24962 15.2015 9.16016 14.79 9.16016C13.3497 9.16016 12.1777 10.3052 12.1777 11.7366Z"
        fill="#231F20"
      />
      <path
        d="M23.5922 12.5776L22.2771 9.26758H21.2305L23.3149 14.3131H23.8337L25.9539 9.26758H24.9162L23.5922 12.5776Z"
        fill="#231F20"
      />
      <path
        d="M26.3926 14.1879H29.1121V13.3559H27.3498V12.0319H29.0495V11.1999H27.3498V10.1085H29.1121V9.26758H26.3926V14.1879Z"
        fill="#231F20"
      />
      <path
        d="M32.913 10.7266C32.913 9.80516 32.2778 9.27734 31.1685 9.27734H29.7461V14.1976H30.7033V12.2206H30.8286L32.1526 14.1976H33.3334L31.7858 12.1222C32.5104 11.9701 32.913 11.4781 32.913 10.7266ZM30.9806 11.5407H30.7033V10.0467H30.9985C31.5979 10.0467 31.92 10.2972 31.92 10.7803C31.92 11.2723 31.5979 11.5407 30.9806 11.5407Z"
        fill="#231F20"
      />
      <path
        d="M18.9141 14.3673C20.3618 14.3673 21.5353 13.1938 21.5353 11.7462C21.5353 10.2985 20.3618 9.125 18.9141 9.125C17.4665 9.125 16.293 10.2985 16.293 11.7462C16.293 13.1938 17.4665 14.3673 18.9141 14.3673Z"
        fill="#F48120"
      />
      <rect
        x={0.75}
        y={0.75}
        width={34.5}
        height={22.5}
        stroke="#CBD5E1"
        strokeWidth={1.5}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-discover" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
